module.exports = __webpack_public_path__ + "static/media/04.Ravana.65ef6cab.jpg";